import {
  Button,
  FormInput,
  FormNumber,
  FormRoot,
  FormSwitch,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";
import type {
  CreateChecklistTypeDTO,
  UpdateChecklistTypeDTO,
} from "../../domain/contracts/type";

const ChecklistTypeFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາປ້ອນຊື່ປະເພດ"),
  orderIndex: z.number().int().default(0),
  isActive: z.boolean().default(true),
});

export type ChecklistTypeFormValues = z.infer<typeof ChecklistTypeFormSchema>;

export function ChecklistTypeForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<ChecklistTypeFormValues>;
  onSubmit: (values: CreateChecklistTypeDTO | UpdateChecklistTypeDTO) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<ChecklistTypeFormValues>({
    // biome-ignore lint/suspicious/noExplicitAny: zodResolver type inference issue
    resolver: zodResolver(ChecklistTypeFormSchema) as any,
    defaultValues: {
      name: "",
      orderIndex: 0,
      isActive: true,
      ...initialValues,
    },
  });

  return (
    <FormRoot<ChecklistTypeFormValues>
      methods={methods}
      onSubmit={(vals) =>
        onSubmit({
          name: vals.name,
          orderIndex: vals.orderIndex ?? 0,
          isActive: vals.isActive ?? true,
        })
      }
      className="space-y-4"
    >
      <FormInput
        name="name"
        label="ຊື່ປະເພດ"
        requiredMark
        placeholder="ຕົວຢ່າງ: ວຽກປະຈໍາ, ເປີດຮ້ານ, ປິດຮ້ານ"
      />
      <FormNumber
        name="orderIndex"
        label="ລໍາດັບ"
        placeholder="0"
        hint="ລໍາດັບສໍາລັບການຈັດລຽງ (ຕໍ່່າກ = ສະແດງກ່ອນ)"
      />
      <FormSwitch
        name="isActive"
        label="ໃຊ້ງານ"
        hint="ປະເພດນີ້ຈະສະແດງໃນລາຍການເລືອກປະເພດ"
      />
      <div className="flex justify-end gap-2">
        <Button
          type="button"
          onClick={methods.handleSubmit(onSubmit)}
          disabled={submitting}
          isLoading={submitting}
        >
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}
